function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M10.5 22.5h3M18 12a6 6 0 10-7.5 5.788V19.5h3v-1.712A5.986 5.986 0 0018 12zm-6-9V1.5m9 9h1.5M1.5 12H3m15.364 5.614l1.061 1.061M4.575 3.825l1.061 1.061m12.728 0l1.061-1.061m-14.85 14.85l1.061-1.061",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
});

function SvgLightBulbShine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    stroke: "currentColor"
  }, props), _ref);
}

export default SvgLightBulbShine;